import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import "./assets/styles/index.css";
import Layout from './components/Layout';
import rootReducer from './reducers';
import createSagaMiddleware from 'redux-saga';
import sagas from './reducers/sagas';
import cognitoInitializer from './services/cognitoInitializer'
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(sagas);
cognitoInitializer()

ReactDOM.render(
  <Provider store={store}>
    <Layout />
  </Provider>
, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js